import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {Link} from "react-router-dom";
import {useGlobal} from 'reactn';


function SearchForm() {

    const [query, setQuery] = useGlobal([]);

    return (
        <div className="SearchForm">
            <Form className="form-inline my-2 my-lg-0">
                <Form.Control id="searchForm" className="form-control mr-sm-2" type="text" placeholder="Search"
                              value={query}
                              aria-label="Search" onChange={event => setQuery(event.target.value)}/>
                <Link to='/advancedsearch'>
                    <Button variant="light" type="submit">Search
                    </Button>
                </Link>
            </Form>
        </div>
    );
}

export default SearchForm;